import Social from "./Social";
import YoloColiving from "../../assets/svgs/YoloIcons/LogoRosaYolo.svg"
import { useEffect,useState } from 'react';

const Footer = () => {

  const [screenSize, setScreenSize] = useState('');
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 768) {
        setScreenSize('desktop');
      } else {
        setScreenSize('smartphone');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
    {screenSize === "desktop" &&
        <>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3 pr0 pl0">
          <div className="footer_about_widget">
            <a href="/">
              <img className="img_yolo_coliving_footer" style={{cursor:"pointer"}} src={YoloColiving} alt="YoloColiving" />
            </a>
            <br />
            <br />
            <p className="fonts_texts_footer_yolo" style={{color:"#3F3F3F"}}>
            O Yolo é a proptech de gestão de moradias, referência em geração de experiências positivas no modelo de serviço ao usuário.
            </p>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="footer_qlink_widget">
            <h4 className="fonts_titles_footer_yolo">Links</h4>
            <ul className="list-unstyled">
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Experiência YOLO</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href={''}>Proprietário</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Hóspede</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Blog</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="footer_contact_widget">
            <h4 className="fonts_titles_footer_yolo">Contato</h4>
            <ul className="list-unstyled">
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Rua da Guia,142</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Recife - PE</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Fale conosco</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="footer_social_widget footer_position">
            <h4 className="fonts_titles_footer_yolo" >Segue a gente</h4>
            <ul className="mb30">
              <Social />
            </ul>
          </div>
        </div>
        </>
        }
        {screenSize === "smartphone" &&
        <>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="footer_about_widget" style={{display:"flex"}}>
            <div style={{width:"50%"}}>
              <a href="/">
                <img style={{cursor:"pointer"}} className="img_yolo_coliving_footer" src={YoloColiving} alt="YoloColiving" />
              </a>
            </div>
            <div style={{width:"50%"}}>
              <p className="fonts_texts_footer_yolo" style={{color:"#3F3F3F"}}>
              O Yolo é a proptech de gestão de moradias, referência em geração de experiências positivas no modelo de serviço ao usuário.
              </p>
            </div>
          </div>
        </div>
        <div style={{display:"flex"}} className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div style={{width:"50%"}}>

          </div>
          <div style={{width:"50%"}} className="footer_qlink_widget" >
            <h4 className="fonts_titles_footer_yolo">Links</h4>
            <ul className="list-unstyled">
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Experiência YOLO</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href={''}>Proprietário</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Hóspede</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Blog</a>
              </li>
            </ul>
          </div>
        </div>

        <div style={{display:"flex"}} className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div style={{width:"50%"}}></div>
          <div style={{width:"50%"}} className="footer_contact_widget">
            <h4 className="fonts_titles_footer_yolo">Contato</h4>
            <ul className="list-unstyled">
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Rua da Guia,142</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Recife - PE</a>
              </li>
              <li>
                <a className="fonts_texts_footer_yolo" style={{color:"#575757"}} href="/#">Fale conosco</a>
              </li>
            </ul>
          </div>
        </div>
        <div style={{display:"flex"}} className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div style={{width:"50%"}}></div>
          <div style={{width:"50%"}} className="footer_social_widget footer_position">
            <h4 className="fonts_titles_footer_yolo" >Segue a gente</h4>
            <ul className="mb30">
              <Social />
            </ul>
          </div>
        </div>
      </>
      }
    </>
  );
};

export default Footer;